import { Box, Header, Text } from '@rbilabs/universal-components';

import { primitive, spacing } from 'styles/constants';
export const Wrapper = Box.withConfig({
  marginX: 'auto',
  maxWidth: {
    base: '$56',
    md: '$64',
  },
  _text: {
    textAlign: 'center',
    margin: 0,
    color: primitive.$greyOne,
  },
  focusable: true,
});

export const Title = Header.withConfig({
  marginTop: 0,
  marginRight: 0,
  marginBottom: '3px',
  marginLeft: 0,
  paddingTop: spacing.$1_5,
  textAlign: 'center',
  color: primitive.$bbqBrown,
  fontSize: 'lg',
  variant: 'headerThree',
  focusable: true,
});

export const CancellationPolicyText = Text.withConfig({
  textAlign: 'center',
  color: primitive.$bbqBrown,
});
